import styled from 'styled-components'

export const Root = styled.ul`
  display: flex;
  flex-direction: column;
  position: relative;
`
